import MainBodySlide from "./MainBodySlide";
import MainBodySlide2 from "./MainBodySlide2";
import MainBodySlide3 from "./MainBodySlide3";
import BulletSlide from "./BulletSlide";
import BulletSlide1 from "./BulletSlide1";
import BulletSlide2 from "./BulletSlide2";
import BulletSlide3 from "./BulletSlide3";
import DataSlide from "./DataSlide";
import DataSlide1 from "./DataSlide1";
import DataSlide2 from "./DataSlide2";
import DataSlide3 from "./DataSlide3";
import DataSlide4 from "./DataSlide4";
import ComparisonSlide1 from "./ComparisonSlide1";
import ComparisonSlide2 from "./ComparisonSlide2";
import FeatureSlide1 from "./FeatureSlide1";
import TimelineSlide1 from "./TimelineSlide1";
import TimelineSlide2 from "./TimelineSlide2";
import ProcessSlide1 from "./ProcessSlide1";
import QuoteSlide from "./QuoteSlide";
import QuoteSlide2 from "./QuoteSlide2";
import finalSchemas from "../final";
import StatSlide from "../extra/StatSlide";
import SupportingSlide from "../extra/SupportingSlide";

export default [
  MainBodySlide,
  MainBodySlide2,
  MainBodySlide3,
  BulletSlide,
  BulletSlide1,
  BulletSlide2,
  BulletSlide3,
  DataSlide,
  DataSlide1,
  DataSlide2,
  DataSlide3,
  DataSlide4,
  ComparisonSlide1,
  ComparisonSlide2,
  FeatureSlide1,
  TimelineSlide1,
  TimelineSlide2,
  ProcessSlide1,
  QuoteSlide,
  QuoteSlide2,
  ...finalSchemas,
  // Extra slides
  StatSlide,
  SupportingSlide,
];
